/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import ClubLists from './component/clubList'
import Permission from '../../components/Permission/index'

class ClubList extends React.Component {
  static defaultProps = {
    clubList: [],
    clubInfo: {},
    walletInfo: [],
    walletRecord: {
      list: [],
    },
    permission: '',
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchClubList().then((res) => {
      this.setState({ loading: false })
    })
  }

  render() {
    const { permission, clubList, clubInfo, walletInfo, walletRecord } =
      this.props
    return (
      <div>
        {permission === 'permission' ? (
          <Permission />
        ) : (
          <ClubLists
            list={clubList}
            clubInfo={clubInfo}
            walletInfo={walletInfo}
            walletRecord={walletRecord}
            searchData={this.props.searchData}
            fetchDeleteClub={this.props.fetchDeleteClub}
            fetchClubInfo={this.props.fetchClubInfo}
            getClubInfo={this.props.getClubInfo}
            fetchEditClub={this.props.fetchEditClub}
            fetchWalletInfo={this.props.fetchWalletInfo}
            fetchWalletRecord={this.props.fetchWalletRecord}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubList: state.getClubList.clubList,
    clubInfo: state.getClubList.clubInfo,
    walletInfo: state.getClubList.walletInfo,
    walletRecord: state.getClubList.walletRecord,
    permission: state.getClubList.permission,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubList))



// WEBPACK FOOTER //
// ./src/containers/ClubList/index.js